__turbopack_context__.v({
  "icon": "styles-module-scss-module__5wJpJW__icon",
  "inverted": "styles-module-scss-module__5wJpJW__inverted",
  "label": "styles-module-scss-module__5wJpJW__label",
  "pill": "styles-module-scss-module__5wJpJW__pill",
});
